import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemMergeMode extends Cloneable {
    static DISABLED = new ItemMergeMode(0, "DISABLED");
    static DEFAULT = new ItemMergeMode(1, "DEFAULT");
    static CUSTOM = new ItemMergeMode(2, "CUSTOM");

    static _values = [
        this.DISABLED,
        this.DEFAULT,
        this.CUSTOM
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemMergeMode.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemMergeMode) {
            return ItemMergeMode._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "DISABLED") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemMergeMode) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemMergeMode());
        } else if (target instanceof ItemMergeMode) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemMergeMode, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});